import Toolbox from '../Toolbox/Toolbox'; 
// SC_ManageGate.js


const SC_ManageGate = {


  getOrlabelFromSettingsbox_product: (settingsbox) => {
    //if (settingsbox && settingsbox.length > 0 && settingsbox[0]['ips-repeater-or-cartgate-product-selection']) {
      //return settingsbox[0]['ips-repeater-or-cartgate-product-selection'];
      if (settingsbox && settingsbox['ips-repeater-or-cartgate-product-selection'] && Array.isArray(settingsbox['ips-repeater-or-cartgate-product-selection'])
      ) {
      return settingsbox['ips-repeater-or-cartgate-product-selection'];
      
    }
    return null; 
  },


  getOrlabelFromSettingsbox_cart: (settingsbox) => {
    //if (settingsbox && settingsbox.length > 0 && settingsbox[0]['ips-repeater-or-cartgate-cart-selection']) {
      //return settingsbox[0]['ips-repeater-or-cartgate-cart-selection'];
   if (settingsbox && settingsbox['ips-repeater-or-cartgate-cart-selection'] && Array.isArray(settingsbox['ips-repeater-or-cartgate-cart-selection'])) {
      return settingsbox['ips-repeater-or-cartgate-cart-selection'];
    }
    return null; 
  },



  checkAllMustTrue: (andArray) => {
    return andArray.every(value => value); // Gibt true zurück, wenn alle Werte wahr sind
  },

  checkMinOneTrue: (andArray) => {
    return andArray.some(value => value === true); // Gibt true zurück, wenn mindestens ein Wert wahr ist
  },







  //<><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><> 
  /******************************************************************************************************************* */
  /******************************************************************************************************************** */

  checkAttributes: (anditem, product_cart_check, theme, producttyp, ipsproducttyp, button, productid) => {
    return true;
  },


  checkCategories: (anditem, product_cart_check, theme, producttyp, ipsproducttyp, button, productid, serverproof, cartitems) => {

    let product_check = false;
    let categories = [];
    let validationcat = anditem;


    if(product_cart_check === 'productcheck'){
      categories = SC_ManageGate.get_general_productcatids(producttyp, button, productid);    //get product cat ids
    }else{
      let { incart_categories } = SC_ManageGate.getDataForTheme(theme, serverproof, cartitems);
      categories = incart_categories;
      //console.log("Cart categories: ",categories);
    }


    


    product_check = SC_ManageGate.check_productlist_to_catonly(categories,validationcat, false, true);

    return product_check;
  },

  checkProducttype: (anditem, product_cart_check, theme, producttyp, ipsproducttyp, button, productid, serverproof, cartitems) => {

    let product_check = false;
    let producttyp_array = [[ipsproducttyp]];
    let validation_ptyp_array = [[anditem]];
    let categories = null;

    if(product_cart_check === 'productcheck'){
      //console.log("Producttype PRODUCT check - addtoProducttyps 1 ",producttyp);
      let flags = ipsproducttyp.split(',').map(str => str.trim());
    let producttyp_array = [flags];
      //console.log("Producttype PRODUCT check - addtoProducttyps 2",ipsproducttyp);
      //console.log("Producttype PRODUCT check - validation",validation_ptyp_array);
      product_check = SC_ManageGate.check_productlist_general_to_producttyp(producttyp_array,validation_ptyp_array, producttyp, button, false, true);
      //console.log("FINAL-PRODUCT CHECK: ",product_check);
    }else{
      //console.log("Producttype CART check");
      let { incart_producttyps } = SC_ManageGate.getDataForTheme(theme, serverproof, cartitems);
      //console.log("Producttype CART check - incartProducttyps ",incart_producttyps);
      //console.log("Producttype CART check - validation",validation_ptyp_array);
      categories = incart_producttyps;
      product_check = SC_ManageGate.check_productlist_to_producttyp(categories,validation_ptyp_array, false, true);
      //console.log("FINAL-CART CHECK: ",product_check);

    }






    return product_check;
  },

  checkProducts: () => {
    return true;
  },

  checkStockStatus: (anditem, product_cart_check, theme, producttyp, ipsproducttyp, button, productid) => {
    return true;
  },

  checkProductCheck: (anditem, product_cart_check, theme, producttyp, ipsproducttyp, button, productid) => {
    return true;
  },














  //<><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><> 
  /******************************************************************************************************************** */
  /******************************************************************************************************************** */





  check_productlist_to_catonly: (incart_cats, validation_cats, exklusiv = false, minonecatid = false) => {
    //console.log("Start 100 -----------");
    //console.log("incart_cats: ",incart_cats);
    let foundValidCombination = false;
  //  console.log("check --check_productlist_to_catonly-- ",incart_cats);
  
    // Überprüfe jede Kombination in incart_cats
    for (let i = 0; i < incart_cats.length; i++) {
      let catIds = incart_cats[i];
      //console.log("check now catIds or ptyps: ",catIds);
  
      // Sortiere die Kategorie-IDs, um die Reihenfolge zu standardisieren
      let sortedCatIds = [...catIds].sort();
      let sortedValidationCats = [...validation_cats].sort();
      
      //console.log("SortCatIDs: ",sortedCatIds);
      //console.log("sortedValidationCats: ",sortedValidationCats);
  
  
      // Überprüfe, ob eine der Kategorie-IDs in sortedCatIds in sortedValidationCats vorhanden ist
      let foundMatch = sortedCatIds.some(id => sortedValidationCats.includes(id));
      //console.log("foundMatch: ",foundMatch);
  
      if (foundMatch && minonecatid) {
        foundValidCombination = true;
      break;
      }
  
      // Überprüfe, ob die Länge der beiden Arrays gleich ist
    //  if (sortedCatIds.length === sortedValidationCats.length) {
     //   console.log("Länge gleich");
        // Überprüfe, ob die beiden Arrays gleich sind
        // Beispiel: sortedCatIds = [1, 2, 3, 4] und sortedValidationCats = [1, 2, 3] --> TRUE nur die ersten drei werden verglichen
        let arraysEqual = sortedCatIds.every((value, index) => value === sortedValidationCats[index]);
        
      //  console.log("ARRAY_EQUAL: ",arraysEqual);
  
        // Wenn die Arrays gleich sind, setze foundValidCombination auf true
        if(exklusiv){
        if (arraysEqual) {
          foundValidCombination = true;
        } else {
          // Wenn eine andere Kombination gefunden wird, setze foundValidCombination auf false und breche die Schleife ab
          foundValidCombination = false;
          break;
        }
      }else{
        if (arraysEqual) {
          foundValidCombination = true;
        }
      }
    //  }
    }
  
    // Gebe den Zustand von foundValidCombination zurück
    return foundValidCombination;
  },





  check_productlist_to_producttyp: (incart_producttyps, validation_producttyps, exklusiv = false, minonecatid = false) => {
    let foundValidCombination = false;
  //  console.log("check --check_productlist_to_catonly-- ",incart_cats);
  
    // Überprüfe jede Kombination in incart_cats
    for (let i = 0; i < incart_producttyps.length; i++) {
      let catIds = incart_producttyps[i];
      //console.log("check now catIds or ptyps: ",catIds);
  
      // Sortiere die Kategorie-IDs, um die Reihenfolge zu standardisieren
      let sortedCatIds = [...catIds].sort();
      let sortedValidationCats = [...validation_producttyps].sort();
      
      //console.log("SortCatIDs: ",sortedCatIds);
      //console.log("sortedValidationCats: ",sortedValidationCats);
  
  
      // Überprüfe, ob eine der Kategorie-IDs in sortedCatIds in sortedValidationCats vorhanden ist
      //let foundMatch = sortedCatIds.some(id => sortedValidationCats.includes(id));
      let foundMatch = sortedCatIds.some(id => sortedValidationCats.flat().includes(id));
      //console.log("foundMatch: ",foundMatch);
  
      if (foundMatch && minonecatid) {
        foundValidCombination = true;
      break;
      }
  
      // Überprüfe, ob die Länge der beiden Arrays gleich ist
    //  if (sortedCatIds.length === sortedValidationCats.length) {
     //   console.log("Länge gleich");
        // Überprüfe, ob die beiden Arrays gleich sind
        // Beispiel: sortedCatIds = [1, 2, 3, 4] und sortedValidationCats = [1, 2, 3] --> TRUE nur die ersten drei werden verglichen
        let arraysEqual = sortedCatIds.every((value, index) => value === sortedValidationCats[index]);
        
      //  console.log("ARRAY_EQUAL: ",arraysEqual);
  
        // Wenn die Arrays gleich sind, setze foundValidCombination auf true
        if(exklusiv){
        if (arraysEqual) {
          foundValidCombination = true;
        } else {
          // Wenn eine andere Kombination gefunden wird, setze foundValidCombination auf false und breche die Schleife ab
          foundValidCombination = false;
          break;
        }
      }else{
        if (arraysEqual) {
          foundValidCombination = true;
        }
      }
    //  }
    }
  
    // Gebe den Zustand von foundValidCombination zurück
    return foundValidCombination;
  },








  check_productlist_general_to_producttyp: (producttyp_array, validation_ptyp_array, producttyp, button, exklusiv = false, minonecatid = false) => {
    let foundValidCombination = false;
  
  
  
    if(producttyp === 'YITH-Together'){
      //let producttyp_array = [[ipsproducttyp]];
      producttyp_array = SC_ManageGate.get_YITHproductTypIds(button);
      //console.log("PTYP_LIST: ",producttyp_array);
      
      foundValidCombination = SC_ManageGate.check_productlist_to_producttyp(producttyp_array,validation_ptyp_array, exklusiv, minonecatid);
    }else{
      foundValidCombination = SC_ManageGate.check_productlist_to_producttyp(producttyp_array,validation_ptyp_array, exklusiv, minonecatid);
    }
  
   
    
  
  
    return foundValidCombination;
  },






  getDataForTheme: (theme, serverproof, cartitems) => {         //Todo-ops here bei ServerRestrictioncheck die CartDaten von dem Server response nehmen 'WoocommerceAPI.getServerCart(baseurl);'
    let incart_categories = [];
    let incart_producttyps = [];
    let cart_amount = 0;
  

    if (theme === 'theme1' && !serverproof) {
      //  Flatsome
        incart_categories = SC_ManageGate.get_catids_fromcart_theme1();
        incart_producttyps = SC_ManageGate.get_producttyps_fromcart();
        cart_amount = SC_ManageGate.get_cartamount_theme1();
      } else if (theme === 'theme2' && !serverproof) {
        //Woodmart localhost_2
        incart_categories = SC_ManageGate.get_catids_fromminicart();
        cart_amount = SC_ManageGate.get_cartamount();
        
      } else if (theme === 'theme0' && !serverproof) {
        //WooOrderCart - Sidecart localhost_1
        incart_categories = SC_ManageGate.get_catids_fromcart();
        incart_producttyps = SC_ManageGate.get_producttyps_fromcart();
        //cart_amount = SidecartControl.get_cartamount_theme0();    //ToDo hier ändern cart_amount von crtItems nehmen

        cart_amount = incart_categories.length;
        
      
      } else if (serverproof){
        incart_categories = SC_ManageGate.get_catids_from_servercart(cartitems);
        incart_producttyps = SC_ManageGate.get_producttyps_from_servercart(cartitems);
        cart_amount = cartitems.metacartdata[0].quantityall;
      }else {
        //console.log("Theme none");
        incart_categories = [];
        cart_amount = 0;
      }

      return { incart_categories, incart_producttyps, cart_amount };


  },


  // ------------------------------------------------------------------------------------------------------------------------------------------
  // ||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||
  // ------------------------------------------------------------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------------------------------------------------------
  // ||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||
  // ------------------------------------------------------------------------------------------------------------------------------------------






  get_general_productcatids: (producttyp, button, productId) => {
    let productCategories = [];
  
  
  
    if(producttyp === 'YITH-Together'){
      productCategories = SC_ManageGate.get_YITHproductcatids(button);
    }else{
      productCategories = SC_ManageGate.get_productcatids(producttyp, button, productId);
    }
  
  
    return productCategories;
  },




  get_YITHproductcatids: (button) => {
    let productCategories = [];
  
    let formcheckbox =  Toolbox.findElementByClassOrTag(button,'yith-wfbt-form', 'form' );
  
    const checkboxes = formcheckbox.querySelectorAll('.yith-wfbt-items .yith-wfbt-item input[type="checkbox"]');
    
    let selectedCategories = []; // Neues Array für die ausgewählten Kategorien
    
    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        const checkboxelement = checkbox.parentElement.closest('li.yith-wfbt-item');
        const hiddenInput = checkboxelement.querySelector('.ips_wooaddtogether_cat');
        if (hiddenInput) {
          const catIds = hiddenInput.getAttribute('data-catids');
          if (catIds) {
            catIds.split(',').forEach(id => selectedCategories.push(id.trim()));
          }
        }
      }
    });
  
    if (selectedCategories.length > 0) {
      productCategories.push(selectedCategories); // Hinzufügen der ausgewählten Kategorien als ein einzelnes Element im productCategories-Array
    }
  
    return productCategories;
  },


  get_YITHproductTypIds: (button) => {
    let productCategories = [];
  
    let formcheckbox =  Toolbox.findElementByClassOrTag(button,'yith-wfbt-form', 'form' );
  
    const checkboxes = formcheckbox.querySelectorAll('.yith-wfbt-items .yith-wfbt-item input[type="checkbox"]');
    
    let selectedCategories = []; // Neues Array für die ausgewählten Kategorien
    
    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        const checkboxelement = checkbox.parentElement.closest('li.yith-wfbt-item');
        const hiddenInput = checkboxelement.querySelector('.ips_wooaddtogether_cat');
        if (hiddenInput) {
          const catIds = hiddenInput.getAttribute('data-ptyp');
          if (catIds) {
            catIds.split(',').forEach(id => selectedCategories.push(id.trim()));
          }
        }
      }
    });
  
    if (selectedCategories.length > 0) {
      productCategories.push(selectedCategories); // Hinzufügen der ausgewählten Kategorien als ein einzelnes Element im productCategories-Array
    }
  
    return productCategories;
  },




  get_productcatids: (producttyp, button, productId) => {
    const productCategories = [];
  
    // Suche zuerst nach Geschwisterelementen
    let siblingElement = button.nextElementSibling;
    while (siblingElement) {
      if (siblingElement.classList.contains('ips_wooadd_cartcats')) {
        const cartCatsValue = siblingElement.getAttribute('data-catids');
        if (cartCatsValue) {
          const catIdsArray = cartCatsValue.split(',').map(id => id.trim());
          productCategories.push(catIdsArray);
        }
        return productCategories; // Beende die Funktion, wenn das Element gefunden wurde
      }
      siblingElement = siblingElement.nextElementSibling;
    }
  
    // Wenn kein Geschwisterelement gefunden wurde, suche in den Eltern-Containern
    let parentElement = button.parentElement;
    while (parentElement) {
      const cartCatsInput = parentElement.querySelector('.ips_wooadd_cartcats');
      if (cartCatsInput) {
        const cartCatsValue = cartCatsInput.getAttribute('data-catids');
        if (cartCatsValue) {
          const catIdsArray = cartCatsValue.split(',').map(id => id.trim());
          productCategories.push(catIdsArray);
        }
        break; // Stoppe die Schleife, nachdem das gewünschte Element gefunden wurde
      }
      parentElement = parentElement.parentElement;
    }
  
    return productCategories;
  },





  get_catids_fromcart_theme1: () => {
    // console.log("Get Cats from Flatsomecart");
   
   //const cartElement = document.getElementById('cfw-cart'); // Das Element mit der ID 'cfw-cart' abrufen
   const cartElement = document.getElementById('cfw-side-cart-form'); // Das Element mit der ID 'cfw-cart' abrufen
   
   if (!cartElement) {
   return "unknown";
   }
     const className = 'ips_wooadd_cat';
     const elements = cartElement.querySelectorAll(`.${className}`); // Nur innerhalb des cfw-cart Elements nach den Elementen suchen
    let categories = [];
   
    elements.forEach(element => {
      let catAttribute = element.getAttribute('data-cat');
      if (catAttribute && catAttribute.length > 0) {
        let catArray = catAttribute.split(', ');
        categories.push(catArray); // Füge das Array der Kategorie-IDs hinzu
      }
    });
   
    return categories;
   
   },


   get_producttyps_fromcart: () => {
    const className = 'ips_wooadd_cat';
    let producttyps = [];
    const elements = document.querySelectorAll(`.${className}`);
  
    elements.forEach((element) => {
      // Hol den Wert aus data-ptyp, z.B. "simple" oder mehrere, kommasepariert
      let rawPtype = element.getAttribute('data-ptyp') || ""; 
      // Zerlege in Array, falls Kommas drin sind
      let flags = rawPtype
        .split(',')
        .map(str => str.trim())
        .filter(Boolean); // filtert leere Einträge raus
  
      // Jetzt weitere Felder hinzunehmen:
      if (element.getAttribute('data-downloadable') === 'yes') {
        flags.push('downloadable');
      }
      if (element.getAttribute('data-virtual') === 'yes') {
        flags.push('virtual');
      }
      // Falls du eigene Flags wie gebrauchtware / differenzbesteuert etc. clientseitig mitgibst:
      if (element.getAttribute('data-gebrauchtware') === 'yes') {
        flags.push('gebrauchtware');
      }
      if (element.getAttribute('data-differenzbesteuert') === 'yes') {
        flags.push('differenzbesteuert');
      }
      // usw.
  
      // Duplizierte Werte entfernen:
      flags = [...new Set(flags)];
  
      // Ab in das große Array
      producttyps.push(flags);
    });
  
    return producttyps;
  },


  get_catids_fromminicart: () => {
    // console.log("Get Cats from Woocommerce SIDECART");
    const className = 'ips-cart-cats';
    const allCartItems = document.querySelectorAll(`.${className}`);
    let categories = [];
   
    if (allCartItems) {
   
      allCartItems.forEach(CartItemelement => {
        const classList = CartItemelement.classList;
        const catIdsClass = Array.from(classList).find(className => className.includes('ipsdata-cat'));
   
        if (catIdsClass) {
          const match = catIdsClass.match(/\(([\d,\s]+)\)/);
   
          // Sicherstellen, dass das Match gültig ist
          if (match) {
            const catIdsString = match[1];
            const newCategories = catIdsString.split(',').map(id => id.trim());
            categories.push(newCategories); // Füge das Array der Kategorie-IDs hinzu
          }
        }
      });
    }
   
    return categories;
   },




  get_cartamount_theme1: () => {
    //const cart_value_cfw = document.querySelector('.cfw-side-cart-quantity').innerHTML;
    //const amount = parseInt(cart_value_cfw);
  
    //return amount;


    const element = document.querySelector('.cfw-side-cart-quantity');
    if (!element) {
        // Element nicht gefunden – handle den Fall, z.B. Rückgabe eines Default-Werts
        return 0;
    }
    const cart_value_cfw = element.innerHTML;
    const amount = parseInt(cart_value_cfw, 10);
    return amount;
  },


  get_cartamount: () => {
    const className = 'ips-cart-cats';
    const firstCartItem = document.querySelector(`.${className}`);
    let amount = 0;
  
    if (firstCartItem) {
      const classList = firstCartItem.classList;
      const cartAmountClass = Array.from(classList).find(className => className.includes('ipsdata-cartamount'));
  
      if (cartAmountClass) {
        const match = cartAmountClass.match(/\((\d+)\)/);
        if (match) {
          amount = parseInt(match[1], 10) || 0;
        }
      }
    }
  
    return amount;
  },



  get_catids_fromcart: () => {
    //console.log("Get Cats from IPS SIDECART");
    const className = 'ips_wooadd_cat';
    let categories = [];
    const elements = document.querySelectorAll(`.${className}`);
  
  
    elements.forEach((element) => {
      let catAttribute = element.getAttribute('data-catids');
      if (catAttribute && catAttribute.length > 0) {
        let catArray = catAttribute.split(', ');
        categories.push(catArray);
      }
    });
  
   // console.log("CATS DIRECT IDS: ",categories);
    return categories;
  },


  get_cats_fromcart: () => {
    const className = 'ips_wooadd_cat';
    let categories = [];
    const elements = document.querySelectorAll(`.${className}`);
   // console.log("Elements binding: ",elements)
  
    elements.forEach((element) => {
      const catAttribute = element.getAttribute('data-cat');
      if (catAttribute && catAttribute.length > 0) {
        const catArray = catAttribute.split(', ');
        categories.push(...catArray);
      }
    });



    
  
    //console.log("CATS DIRECT: ",categories);
    return categories;
  },


  get_catids_from_servercart: (cartitems) => {

    let categories = [];
    if (cartitems && Array.isArray(cartitems.productdata)) {
      cartitems.productdata.forEach((item) => {
        if (item.allcategorieids && item.allcategorieids.length > 0) {
          // Zerlege den String (z. B. "75, 76") in ein Array
          let catArray = item.allcategorieids.split(', ');
          categories.push(catArray);
        }
      });
    }

    return categories;
  },

  get_producttyps_from_servercart: (cartitems) => {
    let producttyps = [];
    if (cartitems && Array.isArray(cartitems.productdata)) {
      cartitems.productdata.forEach((item) => {
        let ptyp = item.producttyp;
        // Falls "variation" zurückgegeben wird, als "variable" interpretieren
        if (ptyp === "variation") {
          ptyp = "variable";
        }
        if (ptyp && ptyp.length > 0) {
          // Falls mehrere Typen durch Komma getrennt sind
          let ptypArray = ptyp.split(', ');
          producttyps.push(ptypArray);
        }
      });
    }
 
     return producttyps;
   },
 

  



  
};

export default SC_ManageGate;